// Customer Experience Default Configuration Constants
// This file contains all default values for auto-generated customer experience configs

// Default UI Styles
export const DEFAULT_UI_STYLES = {
  button: {
    width: 250,
    height: 50,
    widthType: "FIXED",
    heightType: "FIXED",
    borderRadius: 30,
    borderWidth: 2,
    fontSize: 18,
    fontWeight: 100,
    fontStyle: "normal",
    fontColor: "#000",
    backgroundColor: "#FFF",
    borderColor: "#000",
  },
  message: {
    fontSize: 16,
    fontWeight: 400,
    fontColor: "#000",
    fontStyle: "normal",
    textAlign: "center",
  },
  badge: {
    fontSize: 14,
    fontWeight: 400,
    fontColor: "#000",
    backgroundColor: "#ffffff",
  },
};

// Shipping Date Types
export const SHIPPING_DATE_TYPES = {
  ASAP: "ASAP",
  EXACT_DATE: "EXACT_DATE",
  PERIOD: "PERIOD",
  INTERVAL: "INTERVAL",
};

// Billing Policy Types
export const BILLING_POLICY_TYPES = {
  FULL_AMOUNT: "FULL_AMOUNT",
  PARTIAL_PAYMENT: "PARTIAL_PAYMENT",
};

// Remaining Payment Types
export const REMAINING_PAYMENT_TYPES = {
  EXACT_DATE: "EXACT_DATE",
  TIME_AFTER_CHECKOUT: "TIME_AFTER_CHECKOUT",
};

// Pricing Policy Types
export const PRICING_POLICY_TYPES = {
  NO_DISCOUNT: "NO_DISCOUNT",
  PERCENTAGE_DISCOUNT: "PERCENTAGE_DISCOUNT",
  FIXED_AMOUNT_DISCOUNT: "FIXED_AMOUNT_DISCOUNT",
};

// Stock Options
export const STOCK_OPTIONS = {
  WHEN_OUT_OF_STOCK: "WHEN_OUT_OF_STOCK",
  WHEN_SHOPIFY_INVENTORY_AVAILABLE: "WHEN_SHOPIFY_INVENTORY_AVAILABLE",
};

// Inventory Policies
export const INVENTORY_POLICIES = {
  ON_SALE: "ON_SALE",
};

// Timer Configuration Types
export const TIMER_DATE_TYPES = {
  CURRENT: "CURRENT", // Countdown to a date
  FIXED: "FIXED", // Fixed minutes
};

export const TIMER_START_AT = {
  NOW: "NOW", // Timer starts right now
  LATER: "LATER", // Timer starts at a specific time
};

export const TIMER_END_AT = {
  DATE: "DATE", // Specific date
};

export const ONCE_IT_ENDS_OPTIONS = {
  UNPUBLISH_TIMER: "unpublish-timer",
  REPEAT_COUNTDOWN: "repeat-the-countdown",
  SHOW_TITLE: "show-custom-title",
  DO_NOTHING: "do-nothing",
};

// Default Timer Configuration
export const DEFAULT_TIMER_CONFIG = {
  isEnabled: false,
  content: {
    title: "Hurry up!",
    subheading: "Sale ends in:",
    labels: {
      days: "Days",
      hours: "Hrs",
      mins: "Mins",
      secs: "Secs",
    },
    dates: {
      type: TIMER_DATE_TYPES.CURRENT, // Default to countdown to a date
      startAt: TIMER_START_AT.NOW, // Timer starts right now
      startDate: new Date(),
      endAt: TIMER_END_AT.DATE, // Specific date
      endDate: new Date(new Date().getTime() + 24 * 60 * 60 * 1000), // 24 hours from now
      minutes: 1440, // 24 hours in minutes (for fixed timer fallback)
    },
    onceItEnds: {
      value: ONCE_IT_ENDS_OPTIONS.UNPUBLISH_TIMER,
      customTitle: "",
    },
  },
  style: {
    container: {
      background: "#2c2e4a",
      borderRadius: 8,
      borderSize: 0,
      borderColor: "#FFF",
      paddingTop: 30,
      paddingBottom: 30,
      marginTop: 20,
      marginBottom: 20,
    },
    title: {
      fontSize: 30,
      color: "#c4c6e3",
    },
    subheading: {
      fontSize: 18,
      color: "#bdc3fb",
    },
    timer: {
      fontSize: 44,
      color: "#E84545",
    },
    labels: {
      fontSize: 14,
      color: "#bdc3fb",
    },
  },
  placement: "BELOW",
};

// Default Selling Plan Widget Configuration (for partial payment display on product page)
// Note: This widget is only shown when billingPolicyType is PARTIAL_PAYMENT
export const DEFAULT_SELLING_PLAN_WIDGET_CONFIG = {
  content: {
    // Description text shown in the widget
    description: "Pay a deposit now, the rest when it ships.",
  },
  style: {
    // Container styles
    maxWidth: 400,
    borderWidth: 1.5,
    borderColor: "#e5e7eb",
    borderRadius: 8,
    padding: 14,
    // Description font styles
    fontSize: 13,
    fontColor: "#6b7280",
    fontWeight: 400,
    // Radio button styles
    radioSize: 20,
    radioSelectedColor: "#000000",
  },
};

// Default Cart Configuration
export const DEFAULT_CART_CONFIG = {
  // Cart line item label
  label: "Pre-order item delivers as soon as available.",

  // Pre-order alert
  alert: {
    isEnabled: false,
    triggers: {
      onCartPage: true,
      onButtonClick: false,
    },
    content: {
      title: "Important Notice",
      message:
        "By placing this order you acknowledge that you are informed about and agree to our shipping policy, our terms of service and our refund policy.",
      buttonText: "I agree",
      dismissLabel: "Don't show this message again.",
    },
    style: {
      buttonBackgroundColor: "#f70427",
      buttonTextColor: "#FFFFFF",
    },
  },

  // Mixed cart alert (pre-order + regular items)
  mixedAlert: {
    isEnabled: false,
    triggers: {
      onCartPage: true,
      onButtonClick: false,
    },
    content: {
      title: "Important Notice",
      message:
        "Because your cart contains both in-stock products and out-of-stock products your order will be shipped when out-of-stock products are restocked.",
      buttonText: "Okay, Got it!",
      dismissLabel: "Don't show this message again.",
    },
    style: {
      buttonBackgroundColor: "#f70427",
      buttonTextColor: "#FFFFFF",
    },
  },
};

// Default Notify Me Form Configuration
export const DEFAULT_NOTIFY_ME_FORM_CONFIG = {
  content: {
    title: "Notify me when available",
    description: "Subscribe to get notified when this product is back in stock.",
    emailPlaceholder: "Your email (e.g. name@example.com)",
    buttonText: "Notify Me",
    note: "We'll send you an email when this item is available.",
    successMessage: "Thank you! We'll notify you when this product is available.",
    errorMessage: "Something went wrong. Please try again.",
  },
  newsletter: {
    isEnabled: false,
    label: "Subscribe to our newsletter for updates and exclusive offers.",
  },
  style: {
    fontSize: 16,
    borderRadius: 8,
    fieldsBorderRadius: 4,
    headingColor: "#000000",
    textColor: "#333333",
    buttonTextColor: "#FFFFFF",
    buttonBackgroundColor: "#000000",
  },
  showBranding: true,
};

// Default Pre-Order Configuration
export const DEFAULT_PRE_ORDER_CONFIG = {
  stockOption: STOCK_OPTIONS.WHEN_OUT_OF_STOCK,
  shippingDateType: SHIPPING_DATE_TYPES.ASAP,
  shippingDateJsonb: {
    specificDate: new Date().toISOString(),
    periodValue: 1,
    periodType: "DAY",
    periodStart: { value: 1, type: "DAY" },
    periodEnd: { value: 7, type: "DAY" },
  },
  billingPolicyType: BILLING_POLICY_TYPES.FULL_AMOUNT,
  billingPolicyJsonb: {
    upfrontPayment: { type: "PERCENTAGE", value: 10 },
    remainingPaymentType: REMAINING_PAYMENT_TYPES.EXACT_DATE,
    remainingPaymentDate: new Date().toISOString(),
    timeAfterCheckout: { value: 1, unit: "DAY" },
  },
  inventoryPolicy: INVENTORY_POLICIES.ON_SALE,
  pricingPolicyType: PRICING_POLICY_TYPES.NO_DISCOUNT,
  pricingPolicyValue: 0,
  uiConfig: {
    button: {
      type: "DEFAULT",
      text: "Pre-Order",
      addToCartText: "Add to Cart",
      soldOutText: "Sold Out",
      style: { ...DEFAULT_UI_STYLES.button },
    },
    message: {
      text: "Pre-order delivers as soon as available.",
      placementType: "BELOW",
      style: { ...DEFAULT_UI_STYLES.message },
    },
    badge: {
      isEnabled: false,
      text: "Pre-Order",
      type: "RIBBON",
      top: true,
      right: true,
      style: { ...DEFAULT_UI_STYLES.badge },
    },
    timer: { ...DEFAULT_TIMER_CONFIG },
    cart: { ...DEFAULT_CART_CONFIG },
    sellingPlanWidget: { ...DEFAULT_SELLING_PLAN_WIDGET_CONFIG },
    collection: {
      button: {
        type: "DEFAULT",
        text: "Pre-Order",
        addToCartText: "Add to Cart",
        soldOutText: "Sold Out",
        style: { ...DEFAULT_UI_STYLES.button },
      },
      message: {
        text: "Pre-order delivers as soon as available.",
        placementType: "BELOW",
        style: { ...DEFAULT_UI_STYLES.message },
      },
      badge: {
        isEnabled: false,
        text: "Pre-Order",
        type: "RIBBON",
        top: true,
        right: true,
        style: { ...DEFAULT_UI_STYLES.badge },
      },
    },
  },
};

// Default Back in Stock Configuration
export const DEFAULT_BACK_IN_STOCK_CONFIG = {
  stockOption: STOCK_OPTIONS.WHEN_OUT_OF_STOCK,
  quantityThreshold: 1,
  uiConfig: {
    button: {
      type: "CUSTOM",
      text: "Notify when available",
      addToCartText: "Add to Cart",
      soldOutText: "Sold Out",
      style: { ...DEFAULT_UI_STYLES.button },
    },
    message: {
      text: "Subscribe to get notified when this product is back in stock.",
      placementType: "BELOW",
      style: { ...DEFAULT_UI_STYLES.message },
    },
    badge: {
      isEnabled: false,
      text: "Notify Me",
      type: "RIBBON",
      top: true,
      right: true,
      style: { ...DEFAULT_UI_STYLES.badge },
    },
    timer: { ...DEFAULT_TIMER_CONFIG },
    notifyMeForm: { ...DEFAULT_NOTIFY_ME_FORM_CONFIG },
    collection: {
      button: {
        type: "CUSTOM",
        text: "Notify when available",
        addToCartText: "Add to Cart",
        soldOutText: "Sold Out",
        style: { ...DEFAULT_UI_STYLES.button },
      },
      message: {
        text: "Subscribe to get notified when this product is back in stock.",
        placementType: "BELOW",
        style: { ...DEFAULT_UI_STYLES.message },
      },
      badge: {
        isEnabled: false,
        text: "Notify Me",
        type: "RIBBON",
        top: true,
        right: true,
        style: { ...DEFAULT_UI_STYLES.badge },
      },
      notifyMeForm: { ...DEFAULT_NOTIFY_ME_FORM_CONFIG },
    },
  },
};

// Default Coming Soon Configuration
export const DEFAULT_COMING_SOON_CONFIG = {
  stockOption: STOCK_OPTIONS.WHEN_OUT_OF_STOCK,
  uiConfig: {
    button: {
      type: "CUSTOM",
      text: "Coming Soon",
      addToCartText: "Add to Cart",
      soldOutText: "Sold Out",
      style: { ...DEFAULT_UI_STYLES.button },
    },
    message: {
      text: "Product will be available soon.",
      placementType: "BELOW",
      style: { ...DEFAULT_UI_STYLES.message },
    },
    badge: {
      isEnabled: false,
      text: "Coming Soon",
      type: "RIBBON",
      top: true,
      right: true,
      style: { ...DEFAULT_UI_STYLES.badge },
    },
    timer: { ...DEFAULT_TIMER_CONFIG },
    collection: {
      button: {
        type: "CUSTOM",
        text: "Coming Soon",
        addToCartText: "Add to Cart",
        soldOutText: "Sold Out",
        style: { ...DEFAULT_UI_STYLES.button },
      },
      message: {
        text: "Product will be available soon.",
        placementType: "BELOW",
        style: { ...DEFAULT_UI_STYLES.message },
      },
      badge: {
        isEnabled: false,
        text: "Coming Soon",
        type: "RIBBON",
        top: true,
        right: true,
        style: { ...DEFAULT_UI_STYLES.badge },
      },
    },
  },
};

// Default Low Stock Configuration
export const DEFAULT_LOW_STOCK_CONFIG = {
  stockOption: STOCK_OPTIONS.WHEN_SHOPIFY_INVENTORY_AVAILABLE,
  quantityThreshold: 3,
  uiConfig: {
    button: {
      type: "DEFAULT",
      text: "Low Stock",
      addToCartText: "Add to Cart",
      soldOutText: "Sold Out",
      style: { ...DEFAULT_UI_STYLES.button },
    },
    message: {
      text: "Low stock - order now before it sells out!",
      placementType: "BELOW",
      style: { ...DEFAULT_UI_STYLES.message },
    },
    badge: {
      isEnabled: false,
      text: "Low Stock",
      type: "RIBBON",
      top: true,
      right: true,
      style: { ...DEFAULT_UI_STYLES.badge },
    },
    timer: { ...DEFAULT_TIMER_CONFIG },
    collection: {
      button: {
        type: "DEFAULT",
        text: "Low Stock",
        addToCartText: "Add to Cart",
        soldOutText: "Sold Out",
        style: { ...DEFAULT_UI_STYLES.button },
      },
      message: {
        text: "Low stock - order now before it sells out!",
        placementType: "BELOW",
        style: { ...DEFAULT_UI_STYLES.message },
      },
      badge: {
        isEnabled: false,
        text: "Low Stock",
        type: "RIBBON",
        top: true,
        right: true,
        style: { ...DEFAULT_UI_STYLES.badge },
      },
    },
  },
};

// Default Arrays
export const DEFAULT_ARRAYS = {
  markets: [],
  inventoryLocations: [],
};

// Feature Configuration Map
export const FEATURE_CONFIG_MAP = {
  preOrder: {
    enabled: "preOrderEnabled",
    config: "preOrderConfig",
    defaultConfig: DEFAULT_PRE_ORDER_CONFIG,
  },
  backInStock: {
    enabled: "backInStockEnabled",
    config: "backInStockConfig",
    defaultConfig: DEFAULT_BACK_IN_STOCK_CONFIG,
  },
  comingSoon: {
    enabled: "comingSoonEnabled",
    config: "comingSoonConfig",
    defaultConfig: DEFAULT_COMING_SOON_CONFIG,
  },
  lowStock: {
    enabled: "lowStockEnabled",
    config: "lowStockConfig",
    defaultConfig: DEFAULT_LOW_STOCK_CONFIG,
  },
};

// Market and Location Configuration Types
export const MARKET_CONFIG_TYPES = {
  GLOBAL: "GLOBAL",
  ISO_CODE: "ISO_CODE",
  SHOPIFY_MARKET: "SHOPIFY_MARKET",
};

export const LOCATION_CONFIG_TYPES = {
  ALL: "ALL",
  SPECIFIC: "SPECIFIC",
};
